<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-row align-v="center" align-h="center" class="mt-lg-5 mb-4" no-gutters>
          <p style="font-size: 20px;"> 상품 유형을 선택해 주세요 </p>

        </b-row>
        <b-row align-v="center" align-h="center" class="mt-4 mb-4" no-gutters>

          <b-col md="auto" class="mb-2">
            <b-form-group>
              <b-form-radio-group
                id="btn-radios-2"
                v-model="_goodsType"
                :options="goodsTypeOption"
                buttons
                button-variant="outline-primary"
                size="lg"
                name="radio-btn-outline"
                :disabled="this.isModifyMode != false"
              >
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from "vuex";

  export default {
    components: {},
    props: ['registerNew'],
    data() {
      return {
        selectedRadio: 0,
        isModifyMode: false,
        isReqModifyMode: false,
        goodsParamsId: null, //등록된 상품아이디
        registerId: null, //등록대기 상품아이디
        copyRegisterId: null
      }
    },

    computed: {
      ...mapGetters(['goodsTypeOption', 'goodsType']),


      _goodsType: {
        get() {
          return this.goodsType
        },
        set: function(e) {
          this.setGoodsType(e)
        }
      }
    },

    watch: {
      goodsType(val) {
        console.log(val);
        if(val !== null) {

          this.selectGoodsType(false);
        }
      },

    },

    mounted() {

      //신규상품
      this.registerId = this.$route.params.registerId !== undefined ? this.$route.params.registerId : null
      if(this.registerId !== null) {
        this.isReqModifyMode = true
      }

      //등록상품
      this.goodsParamsId = this.$route.params.goodsId !== undefined ? this.$route.params.goodsId : null
      if(this.goodsParamsId !== null) {
        this.isModifyMode = true
      }


    },

    methods: {
      ...mapMutations(['setGoodsType']),


      selectGoodsType(flag) {
        // console.log(flag);
        this.$emit('selectGoodsType', flag)
      },
    },
  }
</script>
